export function useHeader() {

    const pages = {
        home: { title: 'خانه', url: '/', tags: ['اصلی', 'خانه'] },
        courses: { title: 'دوره های من', url: '/courses', tags: ['دوره', 'دوره ها', 'آموزش', 'کلاس', 'درس', 'ویدیو', 'محتوا', 'یادگیری'] },
        transactions: { title: 'اشتراک و تراکنشات', url: '/transactions', tags: ['مالی', 'اشتراک', 'کیف پول', 'تراکنش', 'پرداخت', 'فاکتور', 'صورتحساب', 'پول', 'خرید'] },
        tickets: { title: 'تیکت های من', url: '/tickets', tags: ['تیکت', 'سوال', 'پرسش', 'پشتیبانی', 'مشکل', 'باگ', 'راهنمایی', 'کمک'] },
        questions: { title: 'پرسش و پاسخ ها', url: '/questions', tags: ['سوالات', 'سوال', 'پرسش', 'پاسخ', 'جواب', 'پاسخ', 'فروم', 'بحث'] },
        sessions: { title: 'مشاوره های من', url: '/sessions', tags: ['جلسه', 'مشاوره', 'رزرو', 'زمان', 'میت', 'صحبت', 'گفتگو'] },
        profile: { title: 'ویرایش حساب کاربری', url: null, tags: ['پروفایل', 'ویرایش', 'تنظیمات', 'حساب', 'اکانت', 'اطلاعات شخصی', 'نام', 'ایمیل', 'شماره', 'رمز', 'پسورد', 'تغییر رمز', 'کاربری', 'بیو' ,'پروفایل'] },
    };
    const searchResult = ref([0])
    const searchValue = ref('')
    const searchBoxStatus = ref(false);

    const search = (event) => {
        const query = event.target.value.trim()
        searchValue.value = query

        if (query.length <= 1){
            searchBoxStatus.value = false;
            return;
        }

        const results = Object.entries(pages)
            .filter(([key, page]) =>
                page.title.includes(query) ||
                page.tags.some(tag => tag.includes(query))
            )
            .map(([key, page]) => ({ key, ...page }));
        searchResult.value = results;
        openSearchBox();
    };

    const openSearchBox = () => {
        searchBoxStatus.value = true;
    }
    const closeSearchBox = () => {
        searchBoxStatus.value = false;
        searchValue.value = ''
    }

    return {
        // data
        searchResult,
        searchValue,
        searchBoxStatus,

        // state


        // actions
        closeSearchBox,
        search
    }
}